<template>
    <div :index="index">
        <!-- {{ inforBlock }} -->
        <div v-if="inforBlock.block_type == ALL_BLOCK_TYPE.BLOCK_RADIO" :class="`form-group`">
            <div :class="`fm-answer`">
                <div class="d-flex flex-column">
                    <div class="d-flex align-items-center" :style="`gap: 0.5rem; `">
                        <div v-html="inforBlock.additional_setting.note_left_block" style="min-width: fit-content" />
                        <div>
                            <div
                                class=""
                                :style="`display: grid; grid-template-columns: repeat(${inforBlock.number_of_items_displayed_per_line}, auto)`"
                            >
                                <div v-for="item in inforBlock.option_value" :key="`RadioForm-${item.unique_key}-${inforBlock.id}`">
                                    <InputRadio
                                        :model.sync="defaultForm.choiceValue"
                                        :name="`RadioForm-${inforBlock.id}`"
                                        :id="`RadioForm-${indexRadio}-${item.unique_key}-${inforBlock.id}`"
                                        :value="item.unique_key"
                                        :label="item.value"
                                        :disabled="false"
                                        @change="handleChangeRadio"
                                    />
                                </div>
                            </div>
                            <div v-if="inforBlock?.setting_others?.other_use" :class="`text-${inforBlock?.choice_placement_specification_answer}`">
                                <InputRadio
                                    :model.sync="defaultForm.choiceValue"
                                    :name="`RadioForm-${inforBlock.id}`"
                                    :id="`RadioForm-Others-${indexRadio}-${inforBlock.id}`"
                                    :value="VALUE_ETC"
                                    :label="inforBlock.setting_others.label_other"
                                    :disabled="false"
                                    @change="handleChangeRadio"
                                />
                                <div
                                    :class="`d-flex flex-wrap`"
                                    :style="`gap: 10px; justify-content:${inforBlock.choice_placement_specification_answer}`"
                                >
                                    <InputText
                                        :id="`RadioForm-Others-${index}-${indexRadio}-${inforBlock.id}`"
                                        :model.sync="defaultForm.textValue"
                                        :config.sync="blockConfig.configFieldText"
                                        :disabled="defaultForm.choiceValue !== VALUE_ETC"
                                        @blur="handleValidateField(blockConfig.configFieldText, 'RadioForm-Others')"
                                    />
                                    <div v-if="blockConfig.configFieldText.error" class="d-block invalid-feedback">
                                        {{ blockConfig.configFieldText.errorField }}
                                    </div>
                                </div>
                            </div>
                            <div v-if="inforBlock?.setting_others?.uncheck_use" class="mt-2">
                                <button
                                    class="btn btn-light"
                                    :class="`${true ? 'disabled_cursor' : ''}`"
                                    :disabled="false"
                                    @click="onHandleRemoveRadio"
                                >
                                    {{
                                        inforBlock.setting_others?.label_uncheck
                                            ? inforBlock.setting_others.label_uncheck
                                            : $t('managerForm.settingPage.uncheck')
                                    }}
                                </button>
                            </div>
                            <div
                                v-if="blockConfig.configFieldRadio.error && !blockConfig.configFieldRadio.valueSync"
                                class="d-block invalid-feedback"
                            >
                                {{ blockConfig.configFieldRadio.errorField }}
                            </div>
                        </div>
                        <div v-html="inforBlock.additional_setting.note_right_block" style="min-width: fit-content" />
                    </div>
                    <div :class="`mt-2`" v-html="inforBlock.additional_setting.note_bottom_block" />
                </div>
            </div>
        </div>
        <div v-if="inforBlock.block_type == ALL_BLOCK_TYPE.BLOCK_SELECT" :class="`form-group`">
            <div :class="`fm-answer`">
                <div class="d-flex flex-column">
                    <div class="d-flex align-items-center" :style="`gap: 0.5rem; `">
                        <div v-html="inforBlock.additional_setting.note_left_block" style="min-width: fit-content" />
                        <Multiselect
                            class="col-sm-5"
                            :id="`SelectForm-${inforBlock.id}-${index}-${indexMultiselect}`"
                            :value.sync="defaultForm.choiceValue"
                            :options="onHandleMergeOptionValues(inforBlock.option_value, inforBlock)"
                            :config.sync="blockConfig.configFieldSelect"
                            @select="handleChangeMultiselect"
                        />
                        <div v-html="inforBlock.additional_setting.note_right_block" style="min-width: fit-content" />
                    </div>
                    <div :class="`mt-2`" v-html="inforBlock.additional_setting.note_bottom_block" />
                </div>
            </div>
        </div>
        <div v-if="inforBlock.block_type == ALL_BLOCK_TYPE.BLOCK_CHECKBOX" :class="`form-group`">
            <div :class="`fm-answer text-${inforBlock?.choice_placement_specification_answer}`">
                <div class="d-flex flex-column">
                    <div class="d-flex align-items-center" :style="`gap: 0.5rem; `">
                        <div v-html="inforBlock.additional_setting.note_left_block" style="min-width: fit-content" />
                        <div>
                            <div :style="`display: grid; grid-template-columns: repeat(${inforBlock.number_of_items_displayed_per_line}, auto)`">
                                <div v-for="item in inforBlock.option_value" :key="`CheckBoxForm-${item.unique_key}-${inforBlock.id}`">
                                    <InputCheckBox
                                        :id="`CheckBoxForm-${indexCheckbox}-${item.unique_key}-${inforBlock.id}`"
                                        class="mr-3 mb-2"
                                        :model.sync="defaultForm.choiceValues"
                                        :config="blockConfig.configFieldCheckbox"
                                        :value="item.unique_key"
                                        :label="item.value"
                                        :disabled="disabledLimit[item.unique_key]"
                                        @change="onChangeCheckbox(defaultForm, blockConfig)"
                                    />
                                </div>
                            </div>
                            <div v-if="inforBlock?.setting_others?.other_use" :class="`text-${inforBlock?.choice_placement_specification_answer}`">
                                <InputCheckBox
                                    :id="`OtherCheckBoxForm-${indexCheckbox}-${inforBlock.id}`"
                                    class="mr-3 mb-2"
                                    :model.sync="defaultForm.choiceValues"
                                    :value="VALUE_ETC"
                                    :label="inforBlock.setting_others.label_other"
                                    :disabled="disabledLimit[VALUE_ETC]"
                                    @change="onChangeCheckbox(defaultForm, blockConfig)"
                                />
                                <div
                                    :class="`d-flex flex-wrap`"
                                    :style="`gap: 10px; justify-content:${inforBlock.choice_placement_specification_answer}`"
                                >
                                    <InputText
                                        :id="`OtherCheckBoxForm-${index}-${indexTextCheckbox}-${inforBlock.id}`"
                                        :model.sync="defaultForm.textValue"
                                        :config.sync="blockConfig.configFieldText"
                                        :disabled="!defaultForm.choiceValues.includes(VALUE_ETC)"
                                    />
                                </div>
                            </div>
                            <div v-if="inforBlock?.setting_others?.uncheck_use" :class="`text-${inforBlock?.choice_placement_specification_answer}`">
                                <InputCheckBox
                                    :id="`NotApplicableCheckBoxForm-${indexCheckbox}-${inforBlock.id}`"
                                    :model.sync="defaultForm.choiceValues"
                                    :value="VALUE_NAC"
                                    :label="inforBlock.setting_others.label_uncheck"
                                    :disabled="disabledLimit[VALUE_NAC]"
                                    @change="onChangeCheckbox(defaultForm, blockConfig, 'labelUncheck')"
                                />
                            </div>
                        </div>
                        <div v-html="inforBlock.additional_setting.note_right_block" style="min-width: fit-content" />
                    </div>
                    <div :class="`mt-2`" v-html="inforBlock.additional_setting.note_bottom_block" />
                </div>
            </div>
        </div>
        <div v-if="inforBlock.block_type == ALL_BLOCK_TYPE.BLOCK_SELECT_BOX_PROVINCE" :class="`form-group`">
            <div :class="`fm-answer`">
                <div class="d-flex flex-column">
                    <div class="d-flex align-items-center" :style="`gap: 0.5rem; `">
                        <div v-html="inforBlock.additional_setting.note_left_block" style="min-width: fit-content" />
                        <Multiselect
                            class="col-sm-5 p-0"
                            :id="`SelectProvince-${inforBlock.id}`"
                            :value.sync="defaultForm.choiceValue"
                            :options="onHandleMergeOptionValues(inforBlock.option_value, inforBlock)"
                            :config.sync="blockConfig.configFieldProvince"
                        />
                        <div v-html="inforBlock.additional_setting.note_right_block" style="min-width: fit-content" />
                    </div>
                    <div :class="`mt-2`" v-html="inforBlock.additional_setting.note_bottom_block" />
                </div>
            </div>
        </div>
        <div v-if="inforBlock.block_type == ALL_BLOCK_TYPE.BLOCK_UPLOAD_FILE" :class="`form-group`">
            <div :class="`fm-answer`">
                <div class="d-flex flex-column">
                    <div class="d-flex align-items-center" :style="`gap: 0.5rem; `">
                        <div v-html="inforBlock.additional_setting.note_left_block" style="min-width: fit-content" />
                        <div class="col-4 p-0">
                            <UploadFileCommon
                                :fileValues.sync="defaultForm.choiceValue"
                                :id="`UploadFileForm-${inforBlock.id}`"
                                :typeUpload="`file`"
                                :config="{
                                    maxSize: convertMbToKb(inforBlock.block_upload_file.maximum_file_size)
                                }"
                            />
                        </div>
                        <div v-html="inforBlock.additional_setting.note_right_block" style="min-width: fit-content" />
                    </div>
                    <div :class="`mt-2`" v-html="inforBlock.additional_setting.note_bottom_block" />
                </div>
            </div>
        </div>
        <div v-if="inforBlock.block_type == ALL_BLOCK_TYPE.BLOCK_SEAT_AVAILABILITY" :class="`form-group`">
            <div :class="`fm-answer`">
                <div class="d-flex flex-column">
                    <div class="d-flex align-items-center" :style="`gap: 0.5rem; `">
                        <div v-html="inforBlock.additional_setting.note_left_block" style="min-width: fit-content" />
                        <div>
                            <div
                                class=""
                                :style="`display: grid; grid-template-columns: repeat(${inforBlock.number_of_items_displayed_per_line}, auto)`"
                            >
                                <div v-for="item in inforBlock.option_value" :key="`RemainingSeats-${item.unique_key}-${inforBlock.id}`">
                                    <div
                                        :class="`d-flex flex-wrap`"
                                        :style="`gap: 10px; justify-content:${inforBlock.choice_placement_specification_answer}`"
                                        style="gap: 5px"
                                    >
                                        <InputRadio
                                            :model.sync="defaultForm.choiceValue"
                                            :name="`RemainingSeats`"
                                            :id="`RemainingSeats-${item.unique_key}-${inforBlock.id}`"
                                            :value="item.unique_key"
                                            :label="item.value"
                                            :disabled="false"
                                        />
                                        <div v-if="inforBlock.block_remaining_number.remaining_number === 1">
                                            <span
                                                :style="`color: ${inforBlock.block_remaining_number.color_text ?? ''}; font-size: 12px`"
                                                class="fm_limit_radio_remainder pt-1"
                                            >
                                                {{
                                                    `${inforBlock.block_remaining_number.display_content === 1 ? `(${inforBlock.block_remaining_number.remaining_text}${item.number_of_receptions}${inforBlock.block_remaining_number.text_after_remaining_number})` : inforBlock.block_remaining_number.label_other}`
                                                }}
                                            </span>
                                        </div>
                                    </div>
                                </div>
                            </div>
                            <div
                                v-if="!inforBlock.order_required && inforBlock?.setting_others?.uncheck_use"
                                :class="`d-flex flex-wrap`"
                                :style="`gap: 10px; justify-content:${inforBlock.choice_placement_specification_answer}`"
                            >
                                <InputRadio
                                    :model.sync="defaultForm.choiceValue"
                                    :name="`SeatAvailability-${inforBlock.id}`"
                                    :id="`SeatAvailability-Others-${indexSeatAvailability}-${inforBlock.id}`"
                                    :value="VALUE_NS"
                                    :label="inforBlock.setting_others.label_uncheck"
                                    :disabled="false"
                                />
                            </div>
                        </div>
                        <div v-html="inforBlock.additional_setting.note_right_block" style="min-width: fit-content" />
                    </div>
                    <div :class="`mt-2`" v-html="inforBlock.additional_setting.note_bottom_block" />
                </div>
            </div>
        </div>
    </div>
</template>

<script>
import { InputRadio, InputText, InputCheckBox } from '@/components/Input';
import { validateField } from '@/utils/validate';
import { renderLineBreaks, convertMbToKb } from '@/utils/format';
import { onHandleCheckboxLimited, onHandleMergeOptionValues } from '../../../handlers';
import { ALL_BLOCK_TYPE } from '@/config/constants';
import { VALUE_ETC, VALUE_NAC, VALUE_NS } from '../../../iframe-page/handlers';

import Multiselect from '@/components/Multiselect/main.vue';
import UploadFileCommon from '@/components/Uploads/Files/main.vue';

export default {
    name: 'CommonOption',
    components: {
        InputRadio,
        InputText,
        InputCheckBox,
        Multiselect,
        UploadFileCommon
    },
    props: {
        index: {
            type: Number,
            default: () => 0
        },
        inforBlock: {
            type: Object,
            default: () => null
        },
        formDefault: {
            type: Object,
            default: () => null
        },
        configBlock: {
            type: Object,
            default: () => null
        }
    },
    data() {
        return {
            ALL_BLOCK_TYPE: ALL_BLOCK_TYPE,
            VALUE_ETC: VALUE_ETC,
            VALUE_NAC: VALUE_NAC,
            VALUE_NS: VALUE_NS,
            blockConfig: this.configBlock,
            defaultForm: this.formDefault,
            infoFile: null,
            indexMultiselect: 0,
            indexCheckbox: 0,
            indexTextCheckbox: 0,
            indexRadio: 0,
            indexSeatAvailability: 0,
            disabledLimit: {},
            previousCheckedState: []
        };
    },
    computed: {},
    methods: {
        onHandleMergeOptionValues,
        convertMbToKb,

        handleChangeMultiselect() {
            this.indexMultiselect++;
            this.indexMultiselect = this.indexMultiselect >= 100 ? 0 : this.indexMultiselect;
        },

        handleRemoveMultiselect(configField) {
            this.indexMultiselect--;
            validateField(configField);
        },

        handleValidateField(configField, type = null) {
            if (type == 'OtherCheckBoxForm') {
                this.indexTextCheckbox++;
                this.indexTextCheckbox = this.indexTextCheckbox >= 100 ? 0 : this.indexTextCheckbox;
            }
            if (type == 'RadioForm-Others') {
                this.incrementIndexRadio();
            }
            validateField(configField);
        },

        textLineBreaks(text) {
            return renderLineBreaks(text);
        },

        handleChangeRadio(modelRadio) {
            this.incrementIndexRadio();
            this.defaultForm.valueSync = modelRadio;
            if (modelRadio == VALUE_ETC) {
                if (this.inforBlock.setting_others.value_other_required) {
                    this.blockConfig.configFieldText.typesValidate = ['required'];
                }
            } else {
                this.blockConfig.configFieldText.error = false;
                this.blockConfig.configFieldText.typesValidate = [];
                this.defaultForm.textValue = '';
                this.blockConfig.configFieldText.valueSync = '';
            }
        },

        onHandleRemoveRadio() {
            this.incrementIndexRadio();
            this.defaultForm.choiceValue = '';
            this.defaultForm.textValue = '';
            this.defaultForm.valueSync = '';
            this.blockConfig.configFieldText.valueSync = '';
            this.blockConfig.configFieldText.error = false;
            this.blockConfig.configFieldText.typesValidate = [];
        },

        incrementIndexRadio() {
            this.indexRadio++;
            this.indexRadio = this.indexRadio >= 100 ? 0 : this.indexRadio;
        },

        onChangeCheckbox(modelInforBlock, configInforBlock, typeAction = null) {
            this.indexCheckbox++;
            this.indexCheckbox = this.indexCheckbox >= 100 ? 0 : this.indexCheckbox;

            if (typeAction === 'labelUncheck') {
                if (modelInforBlock.choiceValues.includes(VALUE_NAC)) {
                    this.previousCheckedState = [...modelInforBlock.choiceValues];
                    modelInforBlock.choiceValues = [VALUE_NAC];
                    this.inforBlock.option_value.forEach((optionItem) => {
                        this.disabledLimit[Number(optionItem.unique_key)] = true;
                    });
                    this.disabledLimit[VALUE_ETC] = true;
                } else {
                    this.previousCheckedState = this.previousCheckedState.filter((prItem) => prItem !== VALUE_NAC);
                    modelInforBlock.choiceValues = [...this.previousCheckedState];
                    this.inforBlock.option_value.forEach((optionItem) => {
                        this.disabledLimit[Number(optionItem.unique_key)] = false;
                    });
                    this.disabledLimit[VALUE_ETC] = false;
                }
                return;
            }

            this.disabledLimit = onHandleCheckboxLimited(this.inforBlock, modelInforBlock, this.disabledLimit, 'action');
        }
    },

    watch: {
        formDefault: {
            handler(newValue) {
                if (newValue) {
                    this.defaultForm = newValue;
                }
            },
            deep: true
        },
        configBlock: {
            handler(newValue) {
                if (newValue) {
                    this.blockConfig = newValue;
                }
            },
            deep: true
        },

        defaultForm: {
            handler(newValue) {
                this.$emit('update:formDefault', newValue);
            },
            deep: true
        },
        blockConfig: {
            handler(newValue) {
                this.$emit('update:configBlock', newValue);
            },
            deep: true
        }
    },

    created() {
        this.disabledLimit = onHandleCheckboxLimited(this.inforBlock, this.defaultForm, this.disabledLimit, 'created');
    }
};
</script>

<style lang="scss" scoped></style>
